import React from 'react';
import styles from './InfoNotAvailable.module.css';

export const InfoNotAvailable = ({message}) => {
  return (
    <h1 className={styles.messageWrapper}>{ message }</h1>
  )
}
